import { Component, OnInit, OnDestroy, Compiler, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';

import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { CookieService } from 'ngx-cookie-service';
import { PagerService } from '../../services/index';
import { debug } from 'util';
import { runInThisContext } from 'vm';
//import * as $ from 'jquery';
declare var $: any;
const apiKey = 'AIzaSyCzbE0aKgSn1aVobJoN9H37f7LxH4XUt1I';
var isOpen = "";
var isReportOpen = "";
var inputSurveycomment_text = "";
declare var Material: any;
// Set endpoints
const endpoints = {
	translate: "",
	detect: "detect",
	languages: "languages"
};


@Component({
	selector: 'app-ask-wazzers-video',
	templateUrl: './ask-wazzers-video.component.html',
	styleUrls: ['./ask-wazzers-video.component.css']
})
export class AskWazzersVideoComponent implements OnInit {
	
	id: any;
	UservideoList: any = [];
	videoList: any = [];
	user_id: any;

	html: any;

	question_id: any
	AnswerModal: boolean = false;
	UserQuestionVideoList: any = [];
	question: any
	credit: any
	playVideo:string;
	@ViewChild('videoPlayer') videoplayer: ElementRef;

	constructor(private validationService: ValidationService, private authService: AuthService, private commonService: CommonService,
		private cookieService: CookieService, private router: Router, private pagerService: PagerService, private activatedRoute: ActivatedRoute, private compiler: Compiler) {
		this.activatedRoute.params.subscribe((params: any) => {

			this.user_id = params.user_id;
			this.question_id = params.question_id;
			this.question = params.question
		})

	}

	ngOnInit() {

		this.id = localStorage.getItem('user_id')

		this.getUserQuestionVideoList()

		var that = this;
		setTimeout(function () {
			this.isSurveyAvailable = false;
		}, 1000);
		this.commonService.process();
	}



	PlayVideo(video){
		$('#playuserVideo').modal('show');
		this.playVideo = video.video;
		//this.playVideo = "https://www.w3schools.com/html/mov_bbb.mp4"
	}

	/// get user video question list 
	getUserQuestionVideoList = function () {

		this.authService.getUserQuestionVideoList(this.user_id, this.question_id).subscribe(data => {

			if (data.success) {
				this.UserQuestionVideoList = data.video;
				console.log(data, "data")
				console.log(localStorage.getItem('web_token'))
				this.commonService.hideProcess()
			} else {
				$.growl.error({ title: 'error', message: data.error })
				this.UserQuestionVideoList = [];
			}
		})

	}



	ngOnDestroy() {
		this.compiler.clearCache();
		//this.commonService.isInternetExplorer();
	}



	toggleVideo(event: any) {
		this.videoplayer.nativeElement.play();
	}

	
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/ask-wazzers-video/ask-wazzers-video.component.ts